import classes from './CardEvent.module.css';

export default function CardEvent({ event, onSelect }) {
    const { imageUrl, title, date, location } = event;
    const displayDate = new Date(date).toLocaleDateString('en-IE', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    return (
        <div className={classes.card}>
            <img className={classes.image} src={imageUrl} alt={title} />
            <p className={classes.card__title}>{title}</p>
            <p className={classes.card__text}>{displayDate} · {location}</p>
            <button className={classes.card_button} onClick={() => onSelect(event)}>LEARN MORE</button>
        </div>
    );
}
